import { ONE } from '@/constants';
import { Icon, IconButton } from '@/ui';

import type { FC } from 'react';

interface NavigationProps {
  back: () => void;
  next: () => void;
  page: number;
  pages: number;
}

// Design-system light info IconButton (bloom tonal fill, hover and press feedback
// from the theme). Keyboard focus is stronger than the default: solid bloom fill,
// darker ring and a white arrow, shown only for keyboard focus (focus-visible).
const ARROW_CLASSES =
  'group mr-4 !h-12 !w-14 !rounded-full transition-colors active:!bg-bloom-400 focus-visible:!bg-bloom-500 focus-visible:ring-2 focus-visible:ring-bloom-600 focus-visible:ring-offset-2';

const Navigation: FC<NavigationProps> = ({ back, next, page, pages }) => (
  <div className="mt-auto flex justify-end" data-viewer-nav>
    {page > -ONE && (
      <IconButton
        aria-label="Previous"
        className={ARROW_CLASSES}
        color="info"
        variant="contained"
        light
        onClick={back}
      >
        <Icon className="group-focus-visible:!text-white" color="info">
          chevron_left
        </Icon>
      </IconButton>
    )}
    {page < pages && (
      <IconButton
        aria-label="Next"
        className={ARROW_CLASSES}
        color="info"
        variant="contained"
        light
        onClick={next}
      >
        <Icon className="group-focus-visible:!text-white" color="info">
          chevron_right
        </Icon>
      </IconButton>
    )}
  </div>
);

export default Navigation;
